export const SUPPORT = {
  whatsapp: "https://wa.me/+5533999522052?text=Ol%C3%A1!%20Gostaria%20de%20saber%20mais%20sobre%20a%20NEXORA",
  email: "emersonmikael060@gmail.com",
};